import { pasosDe, primerGrupoQueFalta } from "./pasosDocumentos";

const REQ = { type: "required", message: "Este campo es requerido" };

// Reglas por grupo de documentos (las mismas de siempre, extraídas sin cambios).
const REGLAS = {
    edosCta: (data, docs, errors) => {
        data.edosCta.forEach((file, index) => {
            if (!file.file && file.required) {
                errors[`edosCta.${index}`] = { type: "required", message: "Este campo es requerido" };
            }
        });
    },
    address: (data, docs, errors) => {
        // Verifica si al menos uno de los archivos en el array "address" tiene un valor.
        const hasAnyAddress = data.address.some(item => item.file);
        if (!hasAnyAddress) {
            errors[`address.0`] = { type: "required", message: "Carga al menos un comprobante de domicilio (operativo o fiscal)" };
        }
    },
    references: (data, docs, errors) => {
        const requiredErr = { type: "required", message: "Este campo es requerido" };
        [1, 2, 3].forEach((n) => {
            if (!data[`rf${n}_nombre`]) errors[`rf${n}_nombre`] = requiredErr;
            if (!data[`parent${n}`]) errors[`parent${n}`] = requiredErr;
            if (!data[`tel${n}`]) errors[`tel${n}`] = requiredErr;
        });
        if (!data.checkboxField) {
            errors.checkboxField = requiredErr;
        }
    },
    identifications: (data, docs, errors) => {
        if (!data.identifications[0].file) {
            errors[`identifications.0`] = { type: "required", message: "Este campo es requerido" };
        }
    },
    actaRppPoderes: (data, docs, errors) => {
        data.actaRppPoderes.forEach((file, index) => {
            if (!file.file && file.required) {
                if(file.label == 'poderes') return;
                if(file.label == 'actaRpp') return;
                errors[`actaRppPoderes.${index}`] = { type: "required", message: "Este campo es requerido" };
            }
        });
    },
    edosFinancieros: (data, docs, errors) => {
        if (!data.edosFinancieros[0].file ) {
            errors[`edosFinancieros.0`] = { type: "required", message: "Este campo es requerido" };
        }
    },
    edosCtaAval: (data, docs, errors) => {
        data.edosCtaAval.forEach((file, index) => {
            if (!file.file && file.required) {
                errors[`edosCtaAval.${index}`] = { type: "required", message: "Este campo es requerido" };
            }
        });
    },
    addressAval: (data, docs, errors) => {
        data.addressAval.forEach((file, index) => {
            if (!file.file && file.required) {
                errors[`addressAval.${index}`] = { type: "required", message: "Este campo es requerido" };
            }
        });
    },
};

// Lead del bot (retomaBot === true): se valida SOLO el primer grupo que falta.
const resolverRetoma = (data, page3) => {
    const errors = {};
    const docs = page3.uploadDocuments || {};
    const paso = primerGrupoQueFalta(pasosDe(page3.selectedTypePerson), docs);
    if (!data || Object.keys(data).length === 0) {
        if (paso !== "ok") errors[paso] = { ...REQ };
        return { values: data, errors };
    }
    if (paso === "ok") return { values: data, errors };
    REGLAS[paso](data, docs, errors);
    // en edosCtaAval el comprobante del RL solo se pide si falta; si ya está, no se sube una lista vacía
    if (paso === "edosCtaAval" && !docs.addressAval) REGLAS.addressAval(data, docs, errors);
    return { values: data, errors };
};



export const myResolver = async (data, page3,) => {
    if (page3?.retomaBot === true) return resolverRetoma(data, page3);
    const errors = {};

    const stepsDocs = page3.uploadDocuments;
    const selectedTypePerson = page3.selectedTypePerson;

    // Validación común para todos los tipos de persona

    if (!data || Object.keys(data).length === 0) {
        return {
            values: data,
            errors: {
                rfc: { type: "required", message: "Este campo es requerido" },
                password: { type: "required", message: "Este campo es requerido" },
                confirmPassword: { type: "required", message: "Este campo es requerido" },
                confirmRfc: { type: "required", message: "Este campo es requerido" },
                checkConfirm: { type: "required", message: "Este campo es requerido" },
                // Campos específicos para tipo de persona 1 y 3 (PFAE)
                ...((selectedTypePerson === 1 || selectedTypePerson === 3) && {
                    rf1_nombre: { type: "required", message: "Este campo es requerido" },
                    parent1: { type: "required", message: "Este campo es requerido" },
                    tel1: { type: "required", message: "Este campo es requerido" },
                    rf2_nombre: { type: "required", message: "Este campo es requerido" },
                    parent2: { type: "required", message: "Este campo es requerido" },
                    tel2: { type: "required", message: "Este campo es requerido" },
                    rf3_nombre: { type: "required", message: "Este campo es requerido" },
                    parent3: { type: "required", message: "Este campo es requerido" },
                    tel3: { type: "required", message: "Este campo es requerido" },
                }),
                edosCta: { type: "required", message: "Este campo es requerido" },
                csf: { type: "required", message: "Este campo es requerido" },
                address: { type: "required", message: "Este campo es requerido" },
            },
        };
    }


    // Validaciones basadas en `stepsDocs`
    if (!stepsDocs.edosCta) {
        REGLAS.edosCta(data, stepsDocs, errors);
    }

    if (!stepsDocs.address && stepsDocs.edosCta) {
        REGLAS.address(data, stepsDocs, errors);
    }
    
    // Validación específica para `selectedTypePerson === 1` o 3 (PFAE)
    if ((selectedTypePerson === 1 || selectedTypePerson === 3) && !stepsDocs.reference && stepsDocs.address) {
        REGLAS.references(data, stepsDocs, errors);
    }
    if ((selectedTypePerson === 1 || selectedTypePerson === 3) && stepsDocs.reference) {
        REGLAS.identifications(data, stepsDocs, errors);
    }
    // Validación específica para `selectedTypePerson === 2`
    if (selectedTypePerson === 2) {

        if (!stepsDocs.actaRppPoderes && stepsDocs.address) {
            REGLAS.actaRppPoderes(data, stepsDocs, errors);
        }
        if (!stepsDocs.edosFinancieros && stepsDocs.actaRppPoderes) {
            REGLAS.edosFinancieros(data, stepsDocs, errors);
        }

        if (!stepsDocs.edosCtaAval && stepsDocs.edosFinancieros) {
            REGLAS.edosCtaAval(data, stepsDocs, errors);
            REGLAS.addressAval(data, stepsDocs, errors);
        }
        if ( stepsDocs.edosCtaAval && stepsDocs.addressAval) {
            REGLAS.identifications(data, stepsDocs, errors);
        }
    }

    return {
        values: data,
        errors,
    };
};